import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Eric Chu

 Description:
*/

/*_*/
import { take, put, call } from 'redux-saga/effects';
import { workingStart, workingEnd } from 'wfui-digital-core/es/actions';
import getString from '../../../strings/get-string';
import NavigationItemRecord from '../../../records/NavigationItemRecord';
import { showStopMessage } from '../../stop-message/actions';
import postForm from '../../../network/post-form';
import logger from '../../../logger/logger';
import * as navigation from '../../navigation/actions';
import * as actions from '../actions';

var getNavigationItem = function getNavigationItem(_ref) {
  var url = _ref.url,
      displayType = _ref.displayType;
  return new NavigationItemRecord({
    navigationUrl: url,
    displayType: displayType
  });
};

export var watchGlobalSearchNavigate = /*#__PURE__*/regeneratorRuntime.mark(function watchGlobalSearchNavigate() {
  var _yield$take, url, payload, navigationItem, navigationData, FailureMessageBean, globalMessages, message;

  return regeneratorRuntime.wrap(function watchGlobalSearchNavigate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 36;
            break;
          }

          _context.next = 3;
          return take(actions.GLOBAL_SEARCH_NAVIGATE);

        case 3:
          _yield$take = _context.sent;
          url = _yield$take.url;
          payload = _yield$take.payload;
          _context.next = 8;
          return put(workingStart({
            showSpinner: true
          }));

        case 8:
          navigationItem = void 0;
          _context.prev = 9;

          if (!(url && payload && payload.displayType === undefined)) {
            _context.next = 17;
            break;
          }

          _context.next = 13;
          return call(postForm, {
            url: url,
            includeRootContext: false,
            data: payload
          });

        case 13:
          navigationData = _context.sent;
          navigationItem = getNavigationItem(navigationData.linkNavigationViewBean);
          _context.next = 18;
          break;

        case 17:
          navigationItem = getNavigationItem(payload);

        case 18:
          _context.next = 20;
          return put(navigation.requestNavigation(navigationItem));

        case 20:
          _context.next = 22;
          return put(actions.closeGlobalSearch());

        case 22:
          _context.next = 32;
          break;

        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](9);
          logger.error('Failed to navigate from search results', _context.t0.FailureMessageBean);
          FailureMessageBean = _context.t0.FailureMessageBean || {};
          globalMessages = FailureMessageBean.globalMessages || [{}];
          message = globalMessages[0].message || getString('globalSearch.system.unavailable');
          _context.next = 32;
          return put(showStopMessage(message));

        case 32:
          _context.next = 34;
          return put(workingEnd());

        case 34:
          _context.next = 0;
          break;

        case 36:
        case "end":
          return _context.stop();
      }
    }
  }, watchGlobalSearchNavigate, null, [[9, 24]]);
});